import React from "react";

import { Module } from "src/api/modulesApi";
import { MergeView } from "src/base-components/CodeInput/MergeView";
import { Modal } from "src/design-system/Modal";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  afterLeave: () => void;
  module: Module | undefined;
};

export const SpecDiffModal: React.FC<Props> = ({
  isOpen,
  onClose,
  afterLeave,
  module,
}) => {
  return (
    <Modal afterLeave={afterLeave} open={isOpen} size="lg" onClose={onClose}>
      <Modal.Header
        description={
          module ? `Module ${module.id} · ${module.kind}` : undefined
        }
      >
        Spec Comparison
      </Modal.Header>
      <Modal.Content>
        <div className="flex gap-4 pb-2 font-inter-semibold-12px text-gray-500">
          <span className="flex-1">Current Spec</span>
          <span className="flex-1">Desired Spec</span>
        </div>
        <div className="h-[500px]">
          {module && (
            <MergeView
              modified={JSON.stringify(module.desiredSpec, null, 2)}
              original={JSON.stringify(module.spec, null, 2)}
            />
          )}
        </div>
      </Modal.Content>
      <Modal.Footer primaryButton={false} secondaryButton="Close" />
    </Modal>
  );
};
